import React, { useEffect, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import useCompanyStore from "../hooks/useCompanyStore";
import logo from "../logofull.png";
import { API } from "../constants";

const Footer = () => {
  const { companyId } = useCompanyStore();
  const [settings, setSettings] = useState({
    location: "",
    instagramUrl: "",
    facebookUrl: "",
    email: "",
    contactNo: "",
  });

  const fetchSettings = async () => {
    try {
      const response = await fetch(API.LIST_SETTINGS + "/" + companyId, {
        method: "GET",
        headers: {
          Accept: "application/json",
        },
      });

      const result = await response.json();

      if (!response.ok) {
        throw new Error(result?.message || "Something went wrong");
      }

      if (result?.data?.length > 0) {
        setSettings({
          location: result.data[0].location || "",
          instagramUrl: result.data[0].instagramUrl || "",
          facebookUrl: result.data[0].facebookUrl || "",
          email: result.data[0].email || "",
          contactNo: result.data[0].contactNo || "",
        });
      }
    } catch (error) {
      console.error("Fetch Settings Error:", error);
    }
  };

 useEffect(() => {
  if (!companyId) return;

  fetchSettings();
}, [companyId]);

  return (
    <footer>
      <div className="main-footer">
        <Container>
          <Row>
            <Col md={4}>
              <div className="widget about_widget">
                <div className="footer-logo">
                  <Link to="/">
                    <img
                      src={logo}
                      alt="Movie Booking Logo"
                      className="footer-logo"
                    />
                  </Link>
                </div>

                <p>
                  Enjoy the ultimate movie experience with easy online ticket
                  booking, latest movie listings, premium screens, and comfortable
                  cinema seating. Book your favorite show anytime, anywhere.
                </p>

                <div className="social2">
                  {settings.facebookUrl && (
                    <a
                      className="brd-rd50"
                      href={settings.facebookUrl}
                      title="Facebook"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fa-brands fa-facebook-f"></i>
                    </a>
                  )}

                  {settings.instagramUrl && (
                    <a
                      className="brd-rd50"
                      href={settings.instagramUrl}
                      title="Instagram"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fa-brands fa-instagram"></i>
                    </a>
                  )}
                </div>
              </div>
            </Col>

            <Col md={2}>
              <div className="widget information_links">
                <h4 className="widget-title">Quick Links</h4>
                <ul>
                  <li>
                    <Link to="/">Home</Link>
                  </li>
                  <li>
                    <Link to="/">Movies</Link>
                  </li>
                  <li>
                    <Link to="/theatres">Screens</Link>
                  </li>
                  <li>
                    <Link to="/contact-us">Contact Us</Link>
                  </li>
                </ul>
              </div>
            </Col>

            <Col md={3}>
              <div className="widget information_links">
                <h4 className="widget-title">Other Links</h4>
                <ul>
                  <li>
                    <Link to="/terms-of-service">Terms Of Service</Link>
                  </li>
                  <li>
                    <Link to="/privacy-policy">Privacy Policy</Link>
                  </li>
                  <li>
                    <Link to="/refund-policy">Refund Policy</Link>
                  </li>
                  <li>
                    <Link to="/faq">FAQ</Link>
                  </li>
                </ul>
              </div>
            </Col>

            <Col md={3}>
              <div className="widget get_in_touch">
                <h4 className="widget-title">Get In Touch</h4>
                <ul>
                  {settings.location && (
                    <li>
                      <i className="fa-solid fa-map-pin"></i>{" "}
                      {settings.location}
                    </li>
                  )}

                  {settings.contactNo !== '' && (
                    <li>
                      <i className="fa fa-phone"></i>{" "}
                      <a href={`tel:${settings.contactNo}`}>
                        {settings.contactNo}
                      </a>
                    </li>
                  )}

                  {settings.email && (
                    <li>
                      <i className="fa fa-envelope"></i>{" "}
                      <a href={`mailto:${settings.email}`}>
                        {settings.email}
                      </a>
                    </li>
                  )}
                </ul>
              </div>
            </Col>
          </Row>
        </Container>
      </div>

      <div className="footer-bottom-bar text-center">
        <Container>
          <p>
            &copy; {new Date().getFullYear()}{" "}
            <Link to="/" className="red-clr">
              Movie Booking
            </Link>
            . All Rights Reserved || Designed & Developed By{" "}
            <a
              className="red-clr"
              href="https://www.goigi.com/"
              target="_blank"
              rel="noopener noreferrer"
            >
              GOIGI
            </a>
          </p>
        </Container>
      </div>
    </footer>
  );
};

export default Footer;